import React, { createContext, useContext } from 'react';

const AnalyticsContext = createContext();

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalytics must be used within AnalyticsProvider');
  }
  return context;
};

export const AnalyticsProvider = ({ children }) => {
  // No Google Analytics property is connected yet (this used to configure the literal placeholder
  // 'GA_MEASUREMENT_ID'). When there is one, add gtag('config', 'G-…') next to the Google Ads tag in
  // public/index.html; it then counts page views and the UTM / src tags on its own.

  const trackEvent = (eventName, parameters) => {
    if (window.gtag) {
      window.gtag('event', eventName, parameters);
    }
    console.log('Analytics Event:', eventName, parameters);
  };

  const value = {
    trackEvent,
  };

  return <AnalyticsContext.Provider value={value}>{children}</AnalyticsContext.Provider>;
};